module.exports = __webpack_public_path__ + "img/sodexo-logo-simple.ec19bbc0.svg";